import { useMutation, useQueryClient } from "@tanstack/react-query";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "@/config/firebaseConfig";
import { ReviewStatus } from "@/types/topLevelReciprocalMatch";

export default function useUpdateMatchReviewStatus() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ 
      matchId, 
      reviewStatus 
    }: { 
      matchId: string; 
      reviewStatus: ReviewStatus 
    }) => {
      try {
        await updateDoc(doc(db, `TopLevelReciprocalMatches`, matchId), {
          reviewStatus,
        });
      } catch (error) {
        console.log("Error updating match review status:", error);
        throw error;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["topLevelReciprocalMatches"],
      });
    },
  });
}
